<template>
  <div>
    <b-button
      :to="'/admin/questions/' + $route.params.id"
      class="mb-2"
      variant="info"
      >&lt; Tagasi küsimuse juurde</b-button
    >

    <div v-if="isBusy">
      <div class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Andmeid laetakse..</strong>
      </div>
    </div>

    <b-alert v-else-if="error.length" variant="danger" show>{{
      error
    }}</b-alert>

    <div v-else>
      <h2>{{ question.question }}</h2>

      <b-img
        class="mb-2"
        v-if="question.sponsor_logo"
        :src="question.sponsor_logo"
      />

      <b-list-group class="mb-2">
        <b-list-group-item>
          <strong>Algusaeg:</strong>
          <span class="float-right">{{ question.publish_time }}</span>
        </b-list-group-item>

        <b-list-group-item>
          <strong>Lõpu aeg:</strong>
          <span class="float-right">{{ question.end_time }}</span>
        </b-list-group-item>
      </b-list-group>

      <chart :chartData="chartData"></chart>

      <b-alert v-if="secondaryError.length" variant="danger" show>{{
        secondaryError
      }}</b-alert>

      <b-table
        v-else
        striped
        hover
        :items="votes"
        :fields="fields"
        :busy="dataLoading"
        caption-top
        stacked="md"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Andmeid laetakse..</strong>
          </div>
        </template>

        <template v-slot:table-caption>
          <strong>Kokku hääli:</strong> {{ total }}
        </template>

        <template v-slot:cell(option_id)="data">
          {{ optionValues[data.value] }}
        </template>

        <template v-slot:cell(contacts)="data">
          <p v-if="!data.item.send_campaign_info">
            <strong>Ei soovi kontakti</strong>
          </p>
          <span v-if="data.item.name">{{ data.item.name }}<br /></span>
          <span v-if="data.item.email">{{ data.item.email }}<br /></span>
          <span v-if="data.item.phone">{{ data.item.phone }}</span>
        </template>
      </b-table>

      <b-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="total"
      ></b-pagination>

      <b-button v-if="!downloading" @click="download" variant="primary">Lae alla</b-button>
      <div v-else class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Faili laetakse..</strong>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Chart from "@/components/Chart";

export default {
  name: "VotingResults",
  components: {
    Chart
  },
  data() {
    return {
      id: null,
      error: "",
      isBusy: true,
      dataLoading: false,
      secondaryError: "",
      question: {
        question: "",
        sponsor_logo: "",
        publish_time: "",
        end_time: "",
        options: []
      },
      optionValues: {},
      votes: [],
      fields: [
        {
          key: "option_id",
          label: "Vastus"
        },
        {
          key: "contacts",
          label: "Kontaktid"
        },
        {
          key: "created_at",
          label: "Hääletamise aeg"
        }
      ],
      chartData: {
        labels: ["Vastusevariandid"],
        datasets: []
      },
      currentPage: 1,
      lastPage: 1,
      perPage: 100,
      total: 0,
      downloading: false
    };
  },
  mounted: function() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.fetchQuestion();
    }
  },
  methods: {
    fetchQuestion() {
      this.isBusy = true;
      axios
        .get(
          process.env.VUE_APP_BACKEND_HOST + "/api/v1/questions/" + this.id,
          { timeout: 5000 }
        )
        .then(response => {
          this.error = "";
          for (let key in response.data) {
            if (Object.keys(this.question).includes(key)) {
              this.question[key] = response.data[key];
            }
          }
          let colorScheme = [
            "#E91E63",
            "#FCE4EC",
            "#F8BBD0",
            "#F48FB1",
            "#F06292",
            "#EC407A",
            "#D81B60",
            "#C2185B",
            "#AD1457",
            "#880E4F",
            "#FF80AB",
            "#FF4081",
            "#F50057",
            "#C51162"
          ];
          for (let key in response.data.options) {
            this.optionValues[response.data.options[key].id] =
              response.data.options[key].option;
            this.chartData.datasets.push({
              label: response.data.options[key].option,
              backgroundColor: colorScheme[key % colorScheme.length],
              data: [response.data.options[key].vote_count]
            });
          }
          this.fetchVotes();
        })
        .catch(() => {
          this.error = "Viga serveriga";
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    fetchVotes(page = 1) {
      this.dataLoading = true;
      axios
        .get(
          process.env.VUE_APP_BACKEND_HOST +
            "/api/v1/votes/?per_page=" +
            this.perPage +
            "&page=" +
            page +
            "&question_id=" +
            this.id,
          {
            timeout: 8000
          }
        )
        .then(response => {
          this.secondaryError = "";
          // console.log(response.data);
          this.lastPage = response.data.last_page;
          this.perPage = response.data.per_page;
          this.total = response.data.total;
          this.votes = response.data.data.map(row => {
            return {
              created_at: row.created_at,
              send_campaign_info: row.send_campaign_info,
              option_id: row.option_id,
              name: row.name,
              email: row.email,
              phone: row.phone
            };
          });
        })
        .catch(() => {
          this.secondaryError = "Viga serveriga";
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    download() {
      axios
        .get(process.env.VUE_APP_BACKEND_HOST + "/api/v1/votes?question_id=" + this.id + "&format=csv", { timeout: 10000, responseType: 'blob' })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = fileURL;
          link.setAttribute('download', 'tulemused_' + this.id + '.csv');
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          console.log("EROR");
        });
    }
  },
  watch: {
    currentPage(newValue) {
      this.fetchVotes(newValue);
    }
  }
};
</script>
